import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import TaxFormPdfInterface from './interfaces/TaxFormPdfInterface.interface';

export interface AMOSigningListPDFData {
	application_id: number;
	type: 'tax-form' | 'w8-ben' | 'w9';
}

export type AMOSigningListPDFResponse = {
	status: boolean;
	request_to_signs: TaxFormPdfInterface[];
};

const getSigningListPDF = configRequest<AMOSigningListPDFResponse, AMOSigningListPDFData>({
	requestPrefix: 'applications/getSigningListPDF',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.GET_SIGNING_LIST_PDF(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export default getSigningListPDF;
